import type { ReactElement } from 'react';

export function MetricsSkeleton(): ReactElement {
  return (
    <div
      className="flex flex-col gap-4"
      aria-busy="true"
      data-testid="metrics-skeleton"
    >
      <div
        className="animate-pulse rounded-2xl border p-5 shadow-sm"
        style={{
          background: 'var(--bg-surface)',
          borderColor: 'var(--border)',
        }}
      >
        <div
          className="h-5 w-24 rounded"
          style={{ background: 'var(--bg-primary)' }}
        />
        <div className="mt-3 flex gap-3">
          <div
            className="h-8 w-20 rounded"
            style={{ background: 'var(--bg-primary)' }}
          />
          <div
            className="h-5 w-16 rounded"
            style={{ background: 'var(--bg-primary)' }}
          />
        </div>
        <div className="mt-3 h-4 w-48 rounded" style={{ background: 'var(--bg-primary)' }} />
      </div>

      <div
        className="animate-pulse rounded-2xl border p-5 shadow-sm"
        style={{
          background: 'var(--bg-surface)',
          borderColor: 'var(--border)',
        }}
      >
        <div className="flex justify-between">
          <div
            className="h-5 w-32 rounded"
            style={{ background: 'var(--bg-primary)' }}
          />
          <div
            className="h-6 w-32 rounded"
            style={{ background: 'var(--bg-primary)' }}
          />
        </div>
        <div
          className="mt-4 h-40 w-full rounded"
          style={{ background: 'var(--bg-primary)' }}
        />
      </div>

      <div
        className="animate-pulse rounded-2xl border p-5 shadow-sm"
        style={{
          background: 'var(--bg-surface)',
          borderColor: 'var(--border)',
        }}
      >
        <div
          className="h-5 w-32 rounded"
          style={{ background: 'var(--bg-primary)' }}
        />
        <div
          className="mt-3 h-8 w-full rounded"
          style={{ background: 'var(--bg-primary)' }}
        />
        <div
          className="mt-2 h-8 w-full rounded"
          style={{ background: 'var(--bg-primary)' }}
        />
      </div>
    </div>
  );
}
